/**
 * Created by ddxji on 2016/2/1.
 */

function _isCkApp(){
	var ua = window.navigator.userAgent;
	return ua.indexOf('rrslj-app-agent')>-1;
}

window.token = ''

//自定义事件系统
export var ckEvent = {
	events:{},
	add:function(name,func){
		if(!name.length){
			throw new Error('订阅事件名为空');
		}
		//对init特殊处理
		if(name =='init' && hdk.initialized){
			func();
		}else{
			this.events[name] || (this.events[name]=[]);
			this.events[name].push(func);
		}
	},
	detach:function(name,func){
		if(!name.length){
			throw new Error('取消订阅事件名为空');
		}
		var subEvents = this.events[name];
		if(!subEvents || !subEvents.length)return;
		if(!func){
			this.events[name] = [];
			return;
		}
		for(var i in subEvents){
			if(subEvents.hasOwnProperty(i)){
				//删除注册对象和这个对象下的所有事件
				if(subEvents[i] === func ){
					this.events[name].splice(i,1);
				}
			}
		}
	},
	emit:function(name,val){
		var subEvents = this.events[name];
		if(!subEvents || !subEvents.length)return;
		for(var i=0,len=subEvents.length;i<len;i++){
			subEvents[i](val);
		}
	},
	get:function(name){
		return this.events[name];
	},
	set:function(name,val){
		this.events[name] = val;
	}
};
export var Util = {
	isEmpty: function(object) {
	  // 判断是否为空
	  try {
		if (object == null) {
		  return true;
		}
		switch (typeof object) {
		  case "undefined":
			return true;
			break;
		  case "boolean":
			return false;
			break;
		  case "string":
			if (
			  object.trim() === "" ||
			  object == "null" ||
			  object == "undefined" ||
			  object == "NaN" ||
			  object.indexOf("0000-00-00") > -1
			) {
			  return true;
			}
			break;
		  case "number":
			if (isNaN(object)) {
			  return true;
			}
			break;
		  case "object":
			if (object == null) {
			  return true;
			}
			if (object.length == 0) {
			  return true;
			}
			for (var property in object) {
			  return false;
			}
			return false;
			break;
		  case "function":
			return false;
			break;
		}
		return false;
	  } catch (e) {
		console.log(e);
		return true;
	  }
	},
	getString: function(object) {
	  // 获得String
	  try {
		if (Util.isEmpty(object)) {
		  return "";
		}
		var string = String(object);
		if (Util.isEmpty(string)) {
		  return "";
		}
		return string;
	  } catch (e) {
		console.log(e);
		return "";
	  }
	},
	getIntString: function(object, size) {
	  // 获取填充0的字符串
	  if (Util.isEmpty(size)) {
		size = 1;
	  }
	  object = Util.getInt(object);
	  var index = 1;
	  var result = "";
	  for (var i = 1; i < size; i++) {
		index *= 10;
		if (object < index) {
		  result += "0";
		}
	  }
	  result += object;
	  return result;
	},
	getInt: function(object) {
	  // 获得int
	  try {
		if (Util.isEmpty(object)) {
		  return 0;
		}
		var int = parseInt(object);
		if (Util.isEmpty(int)) {
		  return 0;
		}
		return int;
	  } catch (e) {
		console.log(e);
		return 0;
	  }
	},
	getFloat: function(object) {
	  try {
		if (Util.isEmpty(object)) {
		  return 0.0;
		}
		var float = parseFloat(object);
		if (Util.isEmpty(float)) {
		  return 0.0;
		}
		return float;
	  } catch (e) {
		console.log(e);
		return 0.0;
	  }
	},
	getPrice: function(object) {
	  try {
		if (Util.isEmpty(object)) {
		  return 0;
		}
		if (/\./gi.test(object)) {
		  object = object.toFixed(2);
		}
		return object;
	  } catch (e) {
		console.log(e);
		return 0.0;
	  }
	},
	getDateString: function(date, pattern) {
	  // 获取日期字符
	  try {
		if (Util.isEmpty(date)) {
		  date = new Date();
		}
		if (!(date instanceof Date)) {
		  return "";
		}
		if (Util.isEmpty(pattern)) {
		  pattern = "yyyy-MM-dd HH:mm:ss";
		}
		pattern = Util.getString(pattern);
		pattern = Util.replaceAll(pattern, "yyyy", date.getFullYear());
		pattern = Util.replaceAll(
		  pattern,
		  "MM",
		  Util.getIntString(date.getMonth() + 1, 2)
		);
		pattern = Util.replaceAll(
		  pattern,
		  "dd",
		  Util.getIntString(date.getDate(), 2)
		);
		pattern = Util.replaceAll(
		  pattern,
		  "HH",
		  Util.getIntString(date.getHours(), 2)
		);
		pattern = Util.replaceAll(
		  pattern,
		  "mm",
		  Util.getIntString(date.getMinutes(), 2)
		);
		pattern = Util.replaceAll(
		  pattern,
		  "ss",
		  Util.getIntString(date.getSeconds(), 2)
		);
		return pattern;
	  } catch (e) {
		console.log(e);
		return "";
	  }
	},
	replaceAll: function(tag, s1, s2) {
	  // 替换全部
	  try {
		tag = tag.replace(new RegExp(s1, "gm"), s2);
		return tag;
	  } catch (e) {
		console.log(e);
		return "";
	  }
	},
	getDateStringByMonthCount: function(dateString, countIndex) {
	  var dateArray = dateString.split("-");
	  var year = parseInt(dateArray[0]);
	  var month = parseInt(dateArray[1]);
	  var day = parseInt(dateArray[2]);
	  var date = new Date(year, month + countInex, 0);
	  var maxDay = date.getDate();
	  date = new Date(year, month + countInex - 1, day > maxDay ? maxDay : day);
	  return date
		.toLocaleDateString()
		.match(/\d+/g)
		.join("-");
	}
  };
//APP内重写localstorage方法
ckEvent.add('init',function(){
	//新版app替换localStorage的方法
	if(_isCkApp() && hdk.binding.storage){
		window._localStorage = {};
		_localStorage.setItem = localStorage.setItem;
		_localStorage.getItem = localStorage.getItem;
		_localStorage.removeItem = localStorage.removeItem;
		_localStorage.clear = localStorage.clear;

		//此系统变量无法覆盖成功
		//localStorage = hdk.storage;

		//逐个覆盖
		localStorage.setItem = hdk.storage.setItem;
		localStorage.getItem = hdk.storage.getItem;
		localStorage.removeItem = hdk.storage.removeItem;
		localStorage.clear = hdk.storage.clear;
	}

	// 原生token接受存储本地
	var UserData = JSON.parse(localStorage.getItem("UserData"));
	if (UserData) {
		token = UserData.Token;
	}
});

ckEvent.add('jpush',function(msg){
	var msg = JSON.parse(msg);
	var url = msg.url;
	var subUrl = url.match(/http:\/\/(.+)views\/(.+)$/);
	window.location.href = subUrl[2];
});

// ckEvent.add('slide',function(){
// 	history.back()
// });

//原生调用通知
window.msgNotify = function(osType,msgType,msg){
	ckEvent.emit(msgType,msg);
}

//原生调用通知
//{action:'xxx',param:'xxx',page:['xx']}
window.msgBroadcast = function (msg){
	var obj;
	if(typeof window.CURPAGE_NAME == 'undefined'){
		window.CURPAGE_NAME = '';
	}
	try{
		obj = JSON.parse(msg);
	}catch (e){
		console.error('消息解析出错', e.messsage);
		return;
	}
	if(!obj.page){
		ckEvent.emit(obj.action,obj.param);
	}else if(obj.page == CURPAGE_NAME || obj.page.indexOf(CURPAGE_NAME) > -1){
		ckEvent.emit(obj.action,obj.param);
	}
}

//统一触发 hdk.init
window.hdk && hdk.init('XGJ',function(){
	ckEvent.emit('init');
});


